import React from "react";
import { Reveal, Overline, Stagger, StaggerItem } from "./Reveal";
import { APPROACH } from "../lib/content";

export const VisionApproach = () => (
  <section id="vision" data-testid="vision-section" className="bg-ivory text-navy py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      {/* Vision statement */}
      <Reveal className="max-w-4xl mx-auto text-center">
        <Overline dark>Our Vision</Overline>
        <p className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-balance">
          To build enduring businesses that combine strong brands, disciplined execution, technology, and meaningful customer value — creating an interconnected ecosystem capable of growing across industries and markets.
        </p>
      </Reveal>

      {/* Approach pillars */}
      <div className="mt-28">
        <Reveal className="mb-14">
          <Overline dark>Our Approach</Overline>
          <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight">Four principles guide everything we build.</h2>
        </Reveal>
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {APPROACH.map((a) => (
            <StaggerItem key={a.key} className="bg-ivory p-8 lg:p-10 hover:bg-navy hover:text-ivory transition-colors duration-500 group">
              <span className="font-serif text-3xl text-gold-deep group-hover:text-gold transition-colors">{a.num}</span>
              <h3 className="mt-5 font-serif text-3xl">{a.key}</h3>
              <p className="mt-3 text-sm text-navy/60 group-hover:text-ivory/60 leading-relaxed transition-colors">{a.desc}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>

      {/* Future vision */}
      <div className="mt-28">
        <Reveal className="max-w-3xl">
          <Overline dark>Future Vision</Overline>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">Built for What Comes Next.</h2>
          <p className="mt-6 text-lg text-navy/60 leading-relaxed">
            KRV Nexus is designed with a long-term perspective. As our businesses mature, individual verticals may evolve into independent companies while remaining connected through the KRV ecosystem.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-14 border border-black/10 p-8 lg:p-12 bg-white">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-12">
            <div className="text-center">
              <p className="font-serif text-3xl lg:text-4xl text-navy">KRV Nexus</p>
              <p className="text-xs uppercase tracking-[0.2em] text-navy/40 mt-1">Parent</p>
            </div>
            <span className="text-gold text-2xl rotate-90 lg:rotate-0">→</span>
            <div className="flex gap-6 lg:gap-10">
              {["KRVMart Pvt Ltd", "KRV FinMart Pvt Ltd"].map((n) => (
                <div key={n} className="text-center border border-gold/30 px-6 py-4">
                  <p className="font-serif text-xl lg:text-2xl text-navy">{n}</p>
                </div>
              ))}
            </div>
          </div>
          <p className="mt-8 text-center text-xs uppercase tracking-[0.2em] text-navy/40">
            Future Structure — Subject to Business Scale & Strategic Decisions
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
